@if (isMultiAppointment) {
  <mat-accordion class="block">
    <mat-expansion-panel
      class="!my-[10px]"
      [ngClass]="{'border-b-2 border-b-black': appointment.id === appointmentId}"
      [expanded]="appointment.id === appointmentId">
      <mat-expansion-panel-header
        class="border-b-2 border-green"
        [ngClass]="{'!bg-[#F6F7F7]': appointment.id === appointmentId}"
        [collapsedHeight]="'76px'"
        [expandedHeight]="'76px'">
        <mat-panel-title>
          <div class="w-full">
            <div class="flex w-full justify-between items-center"><h2 class="text-lg mb-1"><strong>Appointment</strong></h2><span>{{formatAppointmentDate}}</span></div>
            <div class="flex">
              <div class="flex w-full justify-between items-center">{{appointment.type}}</div>
              @if (appointment.status !== null) {
                <div class="flex">
                  <div>Status:</div>
                  <div class="ml-1">{{appointment.status}}</div>
                </div>
              }
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="m-[10px] space-y-[10px] p-[10px]">
        <div>
          <strong>Appt Location:</strong>
          <div>{{appointment.location}}</div>
        </div>
        <div>
          <strong>Iowa Ortho Provider:</strong>
          <div>{{appointment.iowaOrthoProvider.firstName}} {{appointment.iowaOrthoProvider.lastName}}</div>
        </div>
        <div>
          <strong>Referring Provider:</strong>
          <div>{{appointment.referringProvider.firstName}} {{appointment.referringProvider.lastName}}</div>
        </div>
      </div>
      @if (shouldShowDocumentsTable) {
        <div class="m-[10px] mt-0 p-[10px]">
          <strong>Documents:</strong>
          <hr class="mb-2 h-[2px] border-0 bg-green" />
          <app-documents-table
            [encounterId]="appointment.encounterId"
            [patientId]="appointment.patient.id"
            [patientFirstName]="appointment.patient.firstName"
            [appointmentDate]="formatAppointmentDate"
            [patientLastName]="appointment.patient.lastName">
          </app-documents-table>
        </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
} @else {
  <div class="m-[10px] bg-white">
    <div class="w-full border-b-2 border-green p-[10px]">
      <div class="flex w-full justify-between items-center"><h2 class="text-lg mb-1"><strong>Appointment</strong></h2><span>{{formatAppointmentDate}}</span></div>
      <div class="flex">
        <div class="flex w-full justify-between items-center">{{appointment.type}}</div>
        @if (appointment.status !== null) {
          <div class="flex">
            <div>Status:</div>
            <div class="ml-1">{{appointment.status}}</div>
          </div>
        }
      </div>
    </div>
    <div class="m-[10px] space-y-[10px] p-[10px]">
      <div>
        <strong>Appt Location:</strong>
        <div>{{appointment.location}}</div>
      </div>
      <div>
        <strong>Iowa Ortho Provider:</strong>
        <div>{{appointment.iowaOrthoProvider.firstName}} {{appointment.iowaOrthoProvider.lastName}}</div>
      </div>
      <div>
        <strong>Referring Provider:</strong>
        <div>{{appointment.referringProvider.firstName}} {{appointment.referringProvider.lastName}}</div>
      </div>
    </div>
    @if (shouldShowDocumentsTable) {
      <div class="m-[10px] mt-0 p-[10px]">
        <strong>Documents:</strong>
        <hr class="mb-2 h-[2px] border-0 bg-green" />
        <app-documents-table
          [encounterId]="appointment.encounterId"
          [patientId]="appointment.patient.id"
          [patientFirstName]="appointment.patient.firstName"
          [appointmentDate]="formatAppointmentDate"
          [patientLastName]="appointment.patient.lastName">
        </app-documents-table>
      </div>
    }
  </div>
}


